<template>
    <div>        
        <table-b  
        :enableScroll="enableScroll"
       :headers="headers" 
       @click-filter="headersUpdated($event)"
       :show-order="true"
        :show-hide-columns-control="showHideColumnsControl"
        :title="title"
       >
        <template v-slot:tbuttons>
            
             <slot name="tbuttons"></slot>
            
          
        </template>
        <template  v-slot:tbuttons-right>
            <slot name="tbuttons-right"></slot>
             
        </template>

         <template  v-slot:free-header-options>
            <slot name="free-header-options"></slot>
             
        </template>
        <template v-slot:tbody>
            <!--Le paso el slot como slot -->
            <slot name="tbody">
                        <tr>
                            <td :colspan="headers.length">
                                No hay resultados disponibles
                                <!--
                                <p v-if="items.length">NO hay res</p>
                                -->
                            </td>
                        </tr>
            </slot>
                
            

        </template>
        <template v-slot:pagination>
            <pagination-d-component v-if="showTablePaginationFooter"
             class="col"
               :collection-size="pagination.collectionSize"
               :current-page="pagination.page" 
               :lst-numeros="pagination.listaPageSize"
                 :actual-show="pagination.actualShow" 
                @prev="page($event)"
                 @next="page($event)" 
                 @onpage="page($event)"
                 @page-size-change="page($event)"></pagination-d-component>
            </template>
       </table-b>
        
    </div>
</template>
<script>

// const rowsOverTableCol6='split-col-middle';
// const rowsOverTableOpen='open';
export default {
    comments:'created by daniel.hernandez.job@gmail.com',
    props:{
        enableScroll: {
            type: Boolean,
            default: false
        },
        headers:{
            //type:Object,
            default:function(){
                return [];
            }
        },
        //main callback to invoke 
        callbackSearch:{
           default:undefined
        },
        showTablePaginationFooter:{
             type:Boolean,
            default:true
        },
        pagination:{
            type:Object,
            default: function(){
                return {
                columnName:'', //change this for anothe property so it can change
                sortOrder:'ASC',
                rfc:'',
                page: 1,                //currentPage
                listaPageSize:[10,20,40,100],
                pageSize: 10 ,//page size de la primera vez, tiene que coincidide con 
                actualShow:0,
                collectionSize: 0, //tamaño del resultado,
                range: {
                    start: new Date(2019, 1, 16), //  
                    end: new Date()    // desde ahora
                }
            }
            }
        },
        showHideColumnsControl:{
        type:Boolean,
        default:false,
        note:"I added this feacture to allow show and hide column, a new control was added, by default this prop is false since it's in use and keep compatibility"
    },
        title: {
        type: String,
        default: ""
    }
        /*
         tableOptionsRow:{
            type:String,
            default:rowsOverTableCol6,// split-col-middle-> indica que se usaran las columnas md-6, open= significa que sera el usuario quien elegira
            note:'Este parametro controla los rows que van encima del table, y van dentro del table-responsive'
        }
        */
    
    },
    data() {
        return {
        }
    },
    mounted() {
        /*
        if(this.callbackSearch){
            this.callbackSearch(this.pagination);
        }*/
    },
    methods: {
         page(pagination) {
           // console.log("page :" + pagination.currentPage);
           // console.log(pagination);
           // eslint-disable-next-line vue/no-mutating-props
            this.pagination.page = pagination.currentPage;
            // eslint-disable-next-line vue/no-mutating-props
            this.pagination.pageSize=pagination.pageSize;
            if(this.callbackSearch){
            this.callbackSearch(this.pagination);
            }
           
        },
        headersUpdated(event){
            // eslint-disable-next-line vue/no-mutating-props
            this.headers=event.headers;
            if(this.pagination.columnName!=event.selectedHeader.index
                || this.pagination.sortOrder!=event.selectedHeader.order){
                // eslint-disable-next-line vue/no-mutating-props
                this.pagination.columnName=event.selectedHeader.index;
                // eslint-disable-next-line vue/no-mutating-props
                this.pagination.sortOrder=event.selectedHeader.order;
              if(this.callbackSearch){
                this.callbackSearch(this.pagination);
                }
            }
        },
        search(optionalParamters){
             if(this.callbackSearch){
                // eslint-disable-next-line
                let pagination={};
                 if(optionalParamters){
                     pagination=this.pagination;
                     pagination =Object.assign(pagination,optionalParamters);
                    }
                this.callbackSearch(this.pagination);
                }
        }
    },
}
</script>